export enum EventNames {
  AbandonedCheckoutPage = 'Abandoned Checkout Page',
  AbTest = 'AB Test',
  AddedCompareModalProductToCart = 'Added Compare Modal Product to Cart',
  AddedProductToCart = 'Added Product to Cart',
  AddedProductToCompare = 'Added Product to Compare',
  AddedStrongholdPaymentSource = 'Added Stronghold Payment Source',
  AlertOptInClicked = 'Alert Opt-In Clicked',
  AlertOptInCompleted = 'Alert Opt-In Completed',
  AlertOptInViewed = 'Alert Opt-In Viewed',
  AllSpecialsTap = 'All Specials Tap',
  BrandDetailPageTap = 'Brand Detail Page Tap',
  BrandPageLoaded = 'Brand Page Loaded',
  BundlePromptTap = 'Bundle Prompt Tap',
  CashBackDetailPageTap = 'Cash Back Detail Page Tap',
  ChangeBankAccountSuccess = 'Change Bank Account Success',
  ChangeBankAccountTap = 'Change Bank Account Tap',
  CheckoutSuccess = 'Checkout Success',
  ClickedBrandLink = 'Clicked Brand Link',
  ClickedBundleEnticementFilter = 'Clicked Bundle Enticement Filter',
  ClickedCart = 'Clicked Cart',
  ClickedCartProductCard = 'Clicked Cart Product Card',
  ClickedCheckout = 'Clicked Checkout',
  ClickedCompare = 'Clicked Compare',
  ClickedCompareModalProduct = 'Clicked Compare Modal Product',
  ClickedContinueShopping = 'Clicked Continue Shopping',
  ClickedHomePageProductCard = 'Clicked HomePage Product Card',
  ClickedImageAd = 'Clicked Image Ad',
  ClickedImageAdProduct = 'Clicked Image Ad Product',
  ClickedMarketplaceProductCard = 'Clicked Marketplace Product Card',
  ClickedMenuProductCard = 'Clicked Menu Product Card',
  ClickedPayWithJanePay = 'Clicked Pay With Jane Pay',
  ClickedPayWithStronghold = 'Clicked Pay With Stronghold',
  ClickedProceedToPayment = 'Clicked Proceed To Payment',
  ClickedSeeAll = 'Clicked See All',
  ClickedShowMore = 'Clicked Show More',
  ClickedStoreInfo = 'Clicked Store Info',
  ClickedStoreNearYou = 'Clicked HomePage Store Near You',
  ClosedCompareModal = 'Closed Compare Modal',
  ClosedLeaveReviewPrompt = 'Closed Leave Review Prompt',
  ConvertedAdSale = 'Converted Ad Sale',
  CustomerRating = 'Customer Rating',
  DeletedAccount = 'Deleted Account',
  DispensaryTap = 'Dispensary Tap',
  EmbeddedMenuRowViewed = 'Embedded Menu Row Viewed',
  FetchedAdCandidatesError = 'Fetched Ad Candidates Error',
  HeaderTap = 'Header Tap',
  HomeTap = 'Home Tap',
  InteractedWithProductReviews = 'Interacted With Product Reviews',
  LinkBankAccountFailed = 'Link Bank Account Failed',
  LinkBankAccountTap = 'Link Bank Account Tap',
  LinkedAeropayBankAccount = 'Linked Aeropay Bank Account',
  LinkedFirstBankAccount = 'Linked First Bank Account',
  LinkedNewBankAccount = 'Linked New Bank Account',
  LoadedCartPage = 'Loaded Cart Page',
  LoadedCheckoutPage = 'Loaded Checkout Page',
  LoadedGuestCheckoutPage = 'Loaded Guest Checkout Page',
  LoadedHomePage = 'Loaded Homepage',
  LoadedLoginRegistrationPage = 'Loaded Login/Registration Page',
  LoadedLoyaltyPoints = 'Loaded Loyalty Points',
  LoadedStoresPage = 'Loaded Stores Page',
  LoadedWriteProductReviewForm = 'Loaded Write Product Review Form',
  LoggedIn = 'Logged In',
  MenuTabTap = 'Tab Tap',
  MenuTap = 'Menu Tap',
  NavBarTap = 'Nav Bar Tap',
  OpenedAccordionItem = 'Opened Accordion Item',
  OpenedCompareModal = 'Opened Compare Modal',
  OpenedPayByLink = 'Opened Pay By Link',
  PageViewed = 'Page Viewed',
  ProductListingTap = 'Product Listing Tap',
  Registered = 'Registered',
  RemovedProductFromCart = 'Removed Product from Cart',
  RenderedImageAdProducts = 'Rendered Image Ad Products',
  ReviewedProduct = 'Reviewed Product',
  SearchedDispensaries = 'Searched Dispensaries',
  SearchedMenuProducts = 'Searched Menu Products',
  SearchedProducts = 'Searched Products',
  SetLocation = 'Set Location',
  SharedProduct = 'Shared Product',
  StartedKioskOrder = 'Started Kiosk Order',
  StoreCommunicationBannerLoaded = 'Store Communication Banner Loaded',
  StoreSet = 'Store Set',
  StoreSpecialPromptTap = 'Store Special Prompt Tap',
  StoreSpecialTap = 'Store Special Tap',
  SubmittedCurbsideForm = 'Submitted Curbside Form',
  SwipedImageAdProducts = 'Swiped Image Ad Products',
  TimedGetJaneDeviceId = 'Timed Get Jane Device ID',
  TimedKioskInactivity = 'Timed Kiosk Inactivity',
  TimedKioskRefreshToLanding = 'Timed Kiosk Refresh To Landing',
  TimedMenuLoad = 'Timed Menu Load',
  UnlinkedLastBankAccount = 'Unlinked Last Bank Account',
  UpdatedProductInCart = 'Updated Product in Cart',
  ViewedBundleEnticement = 'Viewed Bundle Enticement',
  ViewedClickableBundleEnticement = 'Viewed Clickable Bundle Enticement',
  ViewedExperiment = 'Viewed Experiment',
  ViewedImageAd = 'Viewed Image Ad',
  ViewedPaymentSummary = 'Viewed Payment Summary',
  ViewedProduct = 'Viewed Product',
  ViewedProductReviews = 'Viewed Product Reviews',
  ViewedSpecial = 'Viewed Product Special',
  WizardOpened = 'Wizard Opened',
  WizardResultsViewed = 'Wizard Results Viewed',
  WizardSelectionConfirmed = 'Wizard Selection Confirmed',
}
